import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-[calc(5px*var(--radius-scale))] border border-line-strong bg-field px-1 font-sans text-[length:calc(11px*var(--text-scale))] font-medium text-muted',
        className,
      )}
    >
      {children}
    </kbd>
  )
}
